import { ArrowUpRight, Plus, ScanLine } from "lucide-react";
import { formatCurrency, troopContribution } from "@/data/products";

export default function ProductCard({ product, onAdd, onInspect }) {
  const contribution = troopContribution(product.price);
  return (
    <article className="product-card" data-testid={`product-card-${product.id}`}>
      <div className="product-photo">
        <img src={product.imageUrl} alt={product.name} loading="lazy" />
        <span className="product-tier">{product.tier}</span>
        <span className="product-index">TV / {product.number}</span>
        <button className="inspect-float" onClick={() => onInspect(product)} data-testid={`inspect-product-${product.id}`} aria-label={`Inspect ${product.name}`}><ScanLine size={15} /> INSPECT</button>
      </div>
      <div className="product-copy">
        <div className="product-meta"><span>{product.category}</span><span>{product.rating}</span></div>
        <h3 data-testid={`product-name-${product.id}`}>{product.name}</h3>
        <p>{product.description}</p>
        <div className="product-buyline">
          <div><strong data-testid={`product-price-${product.id}`}>{formatCurrency(product.price)}</strong><small data-testid={`product-contribution-${product.id}`}>0.10% / {formatCurrency(contribution)} PLEDGED</small></div>
          <button className="deploy-button" onClick={() => onAdd(product)} data-testid={`deploy-to-cart-${product.id}`}><Plus size={17} /> DEPLOY <ArrowUpRight size={15} /></button>
        </div>
      </div>
    </article>
  );
}
